
import "./nvq-workshop-gampaha.css"
import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';


import ContactLens1 from '../../assets/contactLens1.jpg';
import ContactLens2 from '../../assets/contactLens2.jpg';
import ContactLens3 from '../../assets/contactLens3.jpg'; 
import ContactLens4 from '../../assets/contactLens4.jpg';
import ContactLens5 from '../../assets/contactLens5.jpg';
// import ContactLens6 from '../../assets/contactLens6.jpeg';
// import ContactLens7 from '../../assets/contactLens7.jpeg';
import ContactLens8 from '../../assets/contactLens8.jpg';
// import ContactLens8 from '../../assets/contactLens8.jpeg';
// import ContactLens9 from '../../assets/contactLens9.jpeg';
// import ContactLens10 from '../../assets/contactLens10.jpeg';
// import ContactLens11 from '../../assets/contactLens11.jpeg';



const sections = [

{
    title: ' ',
    images: [ContactLens1, ContactLens2, ContactLens3, ContactLens4, ContactLens5 ],
},

{

images: [ ContactLens8],
},

// {
// images: [  ContactLens6,  ContactLens7, ContactLens8, ContactLens9,],

// },

]





const SpecializedContactLensWorkshop = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
        <h1 align="center">Specialized Contact Lens Workshop - 2026 | @ Eye Care Institute, Colombo </h1>
        <p className="intro-annualmeeting">
         Completed advanced hands-on training in specialized contact lens fitting and clinical application 
         under the guidance of Gagan Sahni and Sumeer Sahni. The workshop covered modern contact 
         lens technologies, patient assessment, fitting techniques, and clinical management for complex 
         visual conditions. Successfully completed intensive training in Orthokeratology (Ortho-K) 
         lens fitting and Scleral Lens application, enhancing expertise in myopia management, 
         corneal rehabilitation, and specialty contact lens care.
        </p>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};


export default SpecializedContactLensWorkshop

